import IUserState from './implements/IUserState.type'

class UserState implements IUserState {
   Id: number
   Email: string
   constructor (id?: number, email?: string) {
     this.Id = id ?? 0
     this.Email = email ?? ''
   }
}

export default UserState
